/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './booking-info.component.css.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '@angular/common';
import * as import3 from '../../../../app/shared/pipe/pretty-id.pipe';
import * as import4 from '../../../../app/shared/pipe/moment-tzdate.pipe';
import * as import5 from '../../../../app/shared/pipe/short-time.pipe';
import * as import6 from '@angular/router';
import * as import7 from '../../../../app/booking-management/booking-info/booking-info.component';
const styles_BookingInfoComponent:any[] = [import0.styles];
export const RenderType_BookingInfoComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_BookingInfoComponent,
  data: {}
}
);
function View_BookingInfoComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Suburb']))
  ]
  ,(null as any),(null as any));
}
function View_BookingInfoComponent_3(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['UR']))
  ]
  ,(null as any),(null as any));
}
function View_BookingInfoComponent_2(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),13,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Client'])),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_3)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Address'])),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Venue'])),
    (l()(),import1.ɵted((null as any),['\n      ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ((co.isCurrentUserAdminOrBookingOfficer() || co.isInterpreter()) && co.selectedBookingModel.deaf_person.ur_number);
    ck(v,6,0,currVal_0);
  },(null as any));
}
function View_BookingInfoComponent_4(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Invitation Summary']))
  ]
  ,(null as any),(null as any));
}
function View_BookingInfoComponent_7(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Tech Contact Name']))
  ]
  ,(null as any),(null as any));
}
function View_BookingInfoComponent_8(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Tech Contact Email']))
  ]
  ,(null as any),(null as any));
}
function View_BookingInfoComponent_9(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Tech Contact Phone']))
  ]
  ,(null as any),(null as any));
}
function View_BookingInfoComponent_10(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Audio Source']))
  ]
  ,(null as any),(null as any));
}
function View_BookingInfoComponent_11(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Tech Platform']))
  ]
  ,(null as any),(null as any));
}
function View_BookingInfoComponent_12(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Login ID Link']))
  ]
  ,(null as any),(null as any));
}
function View_BookingInfoComponent_6(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),19,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_7)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_8)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_9)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_10)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_11)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_12)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.isFieldHasValue(co.selectedBookingModel.tech_contact_first_name) && co.isFieldHasValue(co.selectedBookingModel.tech_contact_last_name));
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.isFieldHasValue(co.selectedBookingModel.tech_contact_email);
    ck(v,6,0,currVal_1);
    const currVal_2:any = co.isFieldHasValue(co.selectedBookingModel.tech_contact_phone_number);
    ck(v,9,0,currVal_2);
    const currVal_3:any = co.isFieldHasValue(co.selectedBookingModel.audio_source);
    ck(v,12,0,currVal_3);
    const currVal_4:any = co.isFieldHasValue(co.selectedBookingModel.tech_platform);
    ck(v,15,0,currVal_4);
    const currVal_5:any = co.isFieldHasValue(co.selectedBookingModel.login_id_link);
    ck(v,18,0,currVal_5);
  },(null as any));
}
function View_BookingInfoComponent_13(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Parking Availability'])),
    (l()(),import1.ɵted((null as any),['\n        ']))
  ]
  ,(null as any),(null as any));
}
function View_BookingInfoComponent_14(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Notes'])),
    (l()(),import1.ɵted((null as any),['\n        ']))
  ]
  ,(null as any),(null as any));
}
function View_BookingInfoComponent_15(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Gender Preference'])),
    (l()(),import1.ɵted((null as any),['\n        ']))
  ]
  ,(null as any),(null as any));
}
function View_BookingInfoComponent_5(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),31,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['People'])),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Contact First Name'])),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Contact Last Name'])),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Contact Mobile'])),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_6)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_13)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Special Instructions'])),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_14)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_15)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',[[
        'name',
        '_attach'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Attached'])),
    (l()(),import1.ɵted((null as any),['\n      ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.isInterpreterStatusAccepted(co.selectedBookingModel);
    ck(v,15,0,currVal_0);
    const currVal_1:any = ((co.isCurrentUserAdminOrBookingOfficer() || co.isClientOrOrgRep()) || co.isInterpreterStatusAccepted(co.selectedBookingModel));
    ck(v,18,0,currVal_1);
    const currVal_2:any = (co.isCurrentUserAdminOrBookingOfficer() || (co.isClientOrOrgRep() && co.isFieldHasValue(co.selectedBookingModel.notes)));
    ck(v,24,0,currVal_2);
    const currVal_3:any = co.showGenderPreference;
    ck(v,27,0,currVal_3);
  },(null as any));
}
function View_BookingInfoComponent_16(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Date Added']))
  ]
  ,(null as any),(null as any));
}
function View_BookingInfoComponent_17(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Days Notice'])),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Updated'])),
    (l()(),import1.ɵted((null as any),['\n      ']))
  ]
  ,(null as any),(null as any));
}
function View_BookingInfoComponent_18(l:any):import1.ɵViewDefinition {
    return import1.ɵvid(0,[(l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'class',
        'icon-requested preff-icon'
      ]
      ,
      [
        'style',
        'color:#00c974'
      ]

    ]
  ,(null as any),(null as any),(null as any),(null as any),(null as any)))],(null as any),(null as any));
}
function View_BookingInfoComponent_19(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,'span',[
      [
        'class',
        'linkId'
      ]
      ,
      [
        'data-title',
        'Link ID'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'a',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '#',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n        ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.selectedBookingModel.link_id;
    ck(v,3,0,currVal_0);
  });
}
function View_BookingInfoComponent_20(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,'td',[
      [
        'class',
        '_suburb'
      ]
      ,
      [
        'data-title',
        'SUBURB'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'a',[[
        'target',
        '_blank'
      ]
      ],[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n          ',
      '\n        '
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n      ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import1.ɵinlineInterpolate(1,'',('https://www.google.com.au/maps/place/' + co.selectedBookingModel.venue.suburb),'');
    ck(v,2,0,currVal_0);
    const currVal_1:any = co.selectedBookingModel.venue.suburb;
    ck(v,3,0,currVal_1);
  });
}
function View_BookingInfoComponent_22(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'td',[
      [
        'data-title',
        'UR'
      ]
      ,
      [
        'id',
        'urNumber'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.selectedBookingModel.deaf_person.ur_number;
    ck(v,1,0,currVal_0);
  });
}
function View_BookingInfoComponent_23(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,'td',[
      [
        'class',
        '_address'
      ]
      ,
      [
        'data-title',
        'ADDRESS'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'a',[[
        'target',
        '_blank'
      ]
      ],[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n            ',
      '',
      '\n          '
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n        ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import1.ɵinlineInterpolate(1,'',((((('https://www.google.com.au/maps/place/' + co.selectedBookingModel.venue.street_number) + ' ') + co.selectedBookingModel.venue.street_name) + ' ') + co.selectedBookingModel.venue.suburb),'');
    ck(v,2,0,currVal_0);
    const currVal_1:any = (co.selectedBookingModel.venue.unit_number? (co.selectedBookingModel.venue.unit_number + '/'): '');
    const currVal_2:any = ((((((((co.selectedBookingModel.venue.street_number + ' ') + co.selectedBookingModel.venue.street_name) + ' ') + co.selectedBookingModel.venue.suburb) + ' ') + co.selectedBookingModel.venue.state) + ' ') + ((co.selectedBookingModel.venue.post_code > 0)? co.selectedBookingModel.venue.post_code: ''));
    ck(v,3,0,currVal_1,currVal_2);
  });
}
function View_BookingInfoComponent_21(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),13,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'td',[
      [
        'class',
        '_client'
      ]
      ,
      [
        'data-title',
        'CLIENT'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n          ',
      '\n        '
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_22)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_23)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'td',[
      [
        'class',
        '_venue'
      ]
      ,
      [
        'data-title',
        'VENUE'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n      ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = ((co.isCurrentUserAdminOrBookingOfficer() || co.isInterpreter()) && co.selectedBookingModel.deaf_person.ur_number);
    ck(v,6,0,currVal_1);
    const currVal_2:any = ((co.isCurrentUserAdminOrBookingOfficer() || co.isClientOrOrgRep()) || co.isInterpreterStatusAccepted(co.selectedBookingModel));
    ck(v,9,0,currVal_2);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ((co.selectedBookingModel.deaf_person.first_name + ' ') + co.selectedBookingModel.deaf_person.last_name);
    ck(v,3,0,currVal_0);
    const currVal_3:any = co.selectedBookingModel.venue.title;
    ck(v,12,0,currVal_3);
  });
}
function View_BookingInfoComponent_24(l:any):import1.ɵViewDefinition {
    return import1.ɵvid(0,[(l()(),import1.ɵeld(0,(null as any),(null as any),0,'td',[
      [
        'data-title',
        'INVITATION SUMMARY'
      ]
      ,
      [
        'id',
        'invitationSummary'
      ]

    ]
      ,[[
        8,
        'innerHTML',
        1
      ]
  ],(null as any),(null as any),(null as any),(null as any)))],(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.findAndReplaceWithLink(co.selectedBookingModel.invitation_summary);
    ck(v,0,0,currVal_0);
  });
}
function View_BookingInfoComponent_27(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'td',[
      [
        'class',
        'tech_name'
      ]
      ,
      [
        'data-title',
        'TECH CONTACT NAME'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ((co.selectedBookingModel.tech_contact_first_name + ' ') + co.selectedBookingModel.tech_contact_last_name);
    ck(v,1,0,currVal_0);
  });
}
function View_BookingInfoComponent_28(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'td',[
      [
        'class',
        'tech_email'
      ]
      ,
      [
        'data-title',
        'TECH CONTACT EMAIL'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.selectedBookingModel.tech_contact_email;
    ck(v,1,0,currVal_0);
  });
}
function View_BookingInfoComponent_29(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'td',[
      [
        'class',
        'tech_phone'
      ]
      ,
      [
        'data-title',
        'TECHCONTACT PHONE NUMBER'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.selectedBookingModel.tech_contact_phone_number;
    ck(v,1,0,currVal_0);
  });
}
function View_BookingInfoComponent_30(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'td',[
      [
        'class',
        'audio_source'
      ]
      ,
      [
        'data-title',
        'AUDIO SOURCE'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.selectedBookingModel.audio_source;
    ck(v,1,0,currVal_0);
  });
}
function View_BookingInfoComponent_31(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'td',[
      [
        'class',
        'tech_platform'
      ]
      ,
      [
        'data-title',
        'TECH PLATFORM'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.selectedBookingModel.tech_platform;
    ck(v,1,0,currVal_0);
  });
}
function View_BookingInfoComponent_32(l:any):import1.ɵViewDefinition {
    return import1.ɵvid(0,[(l()(),import1.ɵeld(0,(null as any),(null as any),0,'td',[
      [
        'class',
        'login_link'
      ]
      ,
      [
        'data-title',
        'LOGIN ID LINK'
      ]

    ]
      ,[[
        8,
        'innerHTML',
        1
      ]
  ],(null as any),(null as any),(null as any),(null as any)))],(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.findAndReplaceWithLink(co.selectedBookingModel.login_id_link);
    ck(v,0,0,currVal_0);
  });
}
function View_BookingInfoComponent_26(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),19,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_27)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_28)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_29)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_30)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_31)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_32)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.isFieldHasValue(co.selectedBookingModel.tech_contact_first_name) && co.isFieldHasValue(co.selectedBookingModel.tech_contact_last_name));
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.isFieldHasValue(co.selectedBookingModel.tech_contact_email);
    ck(v,6,0,currVal_1);
    const currVal_2:any = co.isFieldHasValue(co.selectedBookingModel.tech_contact_phone_number);
    ck(v,9,0,currVal_2);
    const currVal_3:any = co.isFieldHasValue(co.selectedBookingModel.audio_source);
    ck(v,12,0,currVal_3);
    const currVal_4:any = co.isFieldHasValue(co.selectedBookingModel.tech_platform);
    ck(v,15,0,currVal_4);
    const currVal_5:any = co.isFieldHasValue(co.selectedBookingModel.login_id_link);
    ck(v,18,0,currVal_5);
  },(null as any));
}
function View_BookingInfoComponent_33(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'td',[
      [
        'class',
        'parking-availability'
      ]
      ,
      [
        'data-title',
        'PARKING AVAILABILITY'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n        ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.selectedBookingModel.venue.parking_type;
    ck(v,3,0,currVal_0);
  });
}
function View_BookingInfoComponent_25(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),22,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'td',[
      [
        'class',
        'numberofpeople'
      ]
      ,
      [
        'data-title',
        'NUMBER OF PEOPLE'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n          ',
      '\n        '
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'td',[
      [
        'class',
        'contactfirstname'
      ]
      ,
      [
        'data-title',
        'CONTACT FIRST NAME'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'td',[
      [
        'class',
        'contactlastname'
      ]
      ,
      [
        'data-title',
        'CONTACT LAST NAME'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'td',[
      [
        'class',
        'contactmobile'
      ]
      ,
      [
        'data-title',
        'CONTACT MOBILE'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_26)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_33)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'td',[
      [
        'class',
        'new-line specialinstruction'
      ]
      ,
      [
        'data-title',
        'SPECIAL INSTRUCTIONS FOR INTERPRETERS'
      ]

    ]
      ,[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n      ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_4:any = co.isInterpreterStatusAccepted(co.selectedBookingModel);
    ck(v,15,0,currVal_4);
    const currVal_5:any = ((co.isCurrentUserAdminOrBookingOfficer() || co.isClientOrOrgRep()) || co.isInterpreterStatusAccepted(co.selectedBookingModel));
    ck(v,18,0,currVal_5);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.selectedBookingModel.venue.expected_attendance;
    ck(v,3,0,currVal_0);
    const currVal_1:any = co.selectedBookingModel.primaryContact.first_name;
    ck(v,6,0,currVal_1);
    const currVal_2:any = co.selectedBookingModel.primaryContact.last_name;
    ck(v,9,0,currVal_2);
    const currVal_3:any = co.selectedBookingModel.primaryContact.mobile_number;
    ck(v,12,0,currVal_3);
    const currVal_6:any = co.findAndReplaceWithLink(co.selectedBookingModel.special_instructions);
    ck(v,20,0,currVal_6);
  });
}
function View_BookingInfoComponent_34(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),3,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'td',[
      [
        'class',
        '_notes'
      ]
      ,
      [
        'data-title',
        'NOTES'
      ]

    ]
      ,[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.findAndReplaceWithLink(co.selectedBookingModel.notes);
    ck(v,2,0,currVal_0);
  });
}
function View_BookingInfoComponent_35(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'td',[
      [
        'class',
        'booking_gender_preference'
      ]
      ,
      [
        'data-title',
        'GENDER PREFERENCE'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n      ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.selectedBookingModel.gender_preference;
    ck(v,3,0,currVal_0);
  });
}
function View_BookingInfoComponent_38(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),6,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'a',[[
        'download',
        ''
      ]
      ],[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[[
        'class',
        'icon-attach'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      ' ',
      '\n                  '
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n                ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import1.ɵinlineInterpolate(1,'',v.context.$implicit.url,'');
    ck(v,2,0,currVal_0);
    const currVal_1:any = v.context.$implicit.file_name;
    ck(v,5,0,currVal_1);
  });
}
function View_BookingInfoComponent_37(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),12,'ul',[
      [
        'class',
        'dropdown menu custom'
      ]
      ,
      [
        'data-dropdown-menu',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),9,'li',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n              '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'a',[[
        'class',
        'icon-attach'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n              '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'ul',[[
        'class',
        'menu'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n                '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_38)),
    import1.ɵdid(802816,(null as any),0,import2.NgForOf,[
      import1.ViewContainerRef,
      import1.TemplateRef,
      import1.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n              '])),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵted((null as any),['\n          ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.selectedBookingModel.documents_attributes;
    ck(v,9,0,currVal_0);
  },(null as any));
}
function View_BookingInfoComponent_36(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,'td',[
      [
        'align',
        'center'
      ]
      ,
      [
        'data-title',
        'ATTACHMENTS'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_37)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n      ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.selectedBookingModel.documents_attributes.length > 0);
    ck(v,5,0,currVal_0);
  },(null as any));
}
function View_BookingInfoComponent_39(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),2,'td',[[
        'data-title',
        'DATE ADDED'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import1.ɵppd(1)
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import1.ɵunv(v,1,0,ck(v,2,0,import1.ɵnov((<any>v.parent),3),co.selectedBookingModel.created_at));
    ck(v,1,0,currVal_0);
  });
}
function View_BookingInfoComponent_40(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),9,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'td',[[
        'data-title',
        'DAYS NOTICED'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'td',[[
        'data-title',
        'UPDATED'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import1.ɵeld(0,(null as any),(null as any),2,'span',[[
        'class',
        'underline'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import1.ɵppd(1),
    (l()(),import1.ɵted((null as any),['\n      ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.calculateDaysAgo(co.selectedBookingModel.created_at,co.selectedBookingModel.venue.start_time_iso);
    ck(v,3,0,currVal_0);
    const currVal_1:any = import1.ɵunv(v,7,0,ck(v,8,0,import1.ɵnov((<any>v.parent),3),co.selectedBookingModel.updated_at));
    ck(v,7,0,currVal_1);
  });
}
export function View_BookingInfoComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    import1.ɵpid(0,import3.PrettyIDPipe,([] as any[])),
    import1.ɵpid(0,import4.MomentTZDatePipe,([] as any[])),
    import1.ɵpid(0,import5.ShortTimePipe,([] as any[])),
    import1.ɵpid(0,import2.DatePipe,[import1.LOCALE_ID]),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'h2',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Job Details'])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),126,'table',[
      [
        'class',
        'custom-small-table'
      ]
      ,
      [
        'id',
        'job-details-responsive'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),46,'thead',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),43,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Job'])),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Date'])),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Time'])),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Method'])),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Service Type'])),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Org'])),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_1)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_2)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Nature'])),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Specific'])),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_4)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_5)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_16)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_17)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),75,'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),72,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),8,'td',[[
        'data-title',
        'JOB NUMBER'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '\n        ',
      '\n        '
    ]
    )),
    import1.ɵppd(1),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_18)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n        '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_19)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'td',[[
        'data-title',
        'DATE'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),2,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import1.ɵppd(3),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),6,'td',[[
        'data-title',
        'TIME'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),3,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ' - ',
      ''
    ]
    )),
    import1.ɵppd(3),
    import1.ɵppd(3),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'td',[[
        'data-title',
        'METHOD'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'td',[[
        'data-title',
        'SERVICE TYPE'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),7,'td',[[
        'data-title',
        'ORGANISATION'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),4,'a',[[
        'id',
        'lnkOrgName'
      ]
    ],[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,93).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(671744,(null as any),0,import6.RouterLinkWithHref,[
      import6.Router,
      import6.ActivatedRoute,
      import2.LocationStrategy
    ]
    ,{
      queryParams: [
        0,
        'queryParams'
      ]
      ,
      routerLink: [
        1,
        'routerLink'
      ]

    }
    ,(null as any)),
    import1.ɵpod([
      'selectedRole',
      'uid',
      'edit_user'
    ]
    ),
    import1.ɵpad(1),
    (l()(),import1.ɵted((null as any),[
      '\n                   ',
      '\n                    '
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n       '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_20)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_21)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'td',[[
        'data-title',
        'NATURE'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'td',[[
        'data-title',
        'SPECIFIC'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_24)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_25)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_34)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_35)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_36)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_39)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BookingInfoComponent_40)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import7.BookingInfoComponent = v.component;
    const currVal_0:boolean = ((!co.isCurrentUserAdminOrBookingOfficer() && !co.isClientOrOrgRep()) && !co.isInterpreterStatusAccepted(co.selectedBookingModel));
    ck(v,32,0,currVal_0);
    const currVal_1:any = ((co.isCurrentUserAdminOrBookingOfficer() || co.isClientOrOrgRep()) || co.isInterpreterStatusAccepted(co.selectedBookingModel));
    ck(v,35,0,currVal_1);
    const currVal_2:any = (co.isCurrentUserAdminOrBookingOfficer() || (co.isInterpreter() && co.selectedBookingModel.invitation_summary));
    ck(v,44,0,currVal_2);
    const currVal_3:any = ((co.isCurrentUserAdminOrBookingOfficer() || co.isClientOrOrgRep()) || co.isInterpreterStatusAccepted(co.selectedBookingModel));
    ck(v,47,0,currVal_3);
    const currVal_4:any = (co.isCurrentUserAdminOrBookingOfficer() || co.isClientOrOrgRep());
    ck(v,50,0,currVal_4);
    const currVal_5:any = co.isCurrentUserAdminOrBookingOfficer();
    ck(v,53,0,currVal_5);
    const currVal_7:any = co.selectedBookingModel.is_preferred;
    ck(v,65,0,currVal_7);
    const currVal_8:any = (co.isCurrentUserAdminOrBookingOfficer() && !!co.selectedBookingModel.link_id);
    ck(v,68,0,currVal_8);
    const currVal_16:any = ck(v,94,0,co.getQueryableRole('bookable_type'),co.selectedBookingModel.bookable_id,co.stringifyUser('bookable_id'));
    const currVal_17:any = ck(v,95,0,'/init');
    ck(v,93,0,currVal_16,currVal_17);
    const currVal_19:boolean = ((!co.isCurrentUserAdminOrBookingOfficer() && !co.isClientOrOrgRep()) && !co.isInterpreterStatusAccepted(co.selectedBookingModel));
    ck(v,100,0,currVal_19);
    const currVal_20:any = ((co.isCurrentUserAdminOrBookingOfficer() || co.isClientOrOrgRep()) || co.isInterpreterStatusAccepted(co.selectedBookingModel));
    ck(v,103,0,currVal_20);
    const currVal_23:any = (co.isCurrentUserAdminOrBookingOfficer() || (co.isInterpreter() && co.selectedBookingModel.invitation_summary));
    ck(v,112,0,currVal_23);
    const currVal_24:any = ((co.isCurrentUserAdminOrBookingOfficer() || co.isClientOrOrgRep()) || co.isInterpreterStatusAccepted(co.selectedBookingModel));
    ck(v,115,0,currVal_24);
    const currVal_25:any = (co.isCurrentUserAdminOrBookingOfficer() || (co.isClientOrOrgRep() && co.isFieldHasValue(co.selectedBookingModel.notes)));
    ck(v,118,0,currVal_25);
    const currVal_26:any = co.showGenderPreference;
    ck(v,121,0,currVal_26);
    const currVal_27:any = ((co.isCurrentUserAdminOrBookingOfficer() || co.isClientOrOrgRep()) || co.isInterpreterStatusAccepted(co.selectedBookingModel));
    ck(v,124,0,currVal_27);
    const currVal_28:any = (co.isCurrentUserAdminOrBookingOfficer() || co.isClientOrOrgRep());
    ck(v,127,0,currVal_28);
    const currVal_29:any = co.isCurrentUserAdminOrBookingOfficer();
    ck(v,130,0,currVal_29);
  },(ck,v) => {
    var co:import7.BookingInfoComponent = v.component;
    const currVal_6:any = import1.ɵunv(v,62,0,ck(v,63,0,import1.ɵnov(v,0),co.selectedBookingModel.id));
    ck(v,62,0,currVal_6);
    const currVal_9:any = import1.ɵunv(v,73,0,ck(v,74,0,import1.ɵnov(v,1),co.selectedBookingModel.venue.start_time_iso,co.selectedBookingModel.venue.state,co.selectedBookingModel.venue.post_code));
    ck(v,73,0,currVal_9);
    const currVal_10:any = import1.ɵunv(v,79,0,ck(v,80,0,import1.ɵnov(v,2),co.selectedBookingModel.venue.start_time_iso,co.selectedBookingModel.venue.state,co.selectedBookingModel.venue.post_code));
    const currVal_11:any = import1.ɵunv(v,79,1,ck(v,81,0,import1.ɵnov(v,2),co.selectedBookingModel.venue.end_time_iso,co.selectedBookingModel.venue.state,co.selectedBookingModel.venue.post_code));
    ck(v,79,0,currVal_10,currVal_11);
    const currVal_12:any = co.selectedBookingModel.method_name;
    ck(v,85,0,currVal_12);
    const currVal_13:any = co.selectedBookingModel.service_type;
    ck(v,88,0,currVal_13);
    const currVal_14:any = import1.ɵnov(v,93).target;
    const currVal_15:any = import1.ɵnov(v,93).href;
    ck(v,92,0,currVal_14,currVal_15);
    const currVal_18:any = co.selectedBookingModel.client.organisation_name;
    ck(v,96,0,currVal_18);
    const currVal_21:any = co.selectedBookingModel.nature_of_appointment;
    ck(v,106,0,currVal_21);
    const currVal_22:any = co.selectedBookingModel.specific_nature_of_appointment;
    ck(v,109,0,currVal_22);
  });
}
function View_BookingInfoComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-booking-info',([] as any[]),(null as any),(null as any),(null as any),View_BookingInfoComponent_0,RenderType_BookingInfoComponent)),
    import1.ɵdid(49152,(null as any),0,import7.BookingInfoComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const BookingInfoComponentNgFactory:import1.ComponentFactory<import7.BookingInfoComponent> = import1.ɵccf('app-booking-info',import7.BookingInfoComponent,View_BookingInfoComponent_Host_0,{selectedBookingModel: 'selectedBookingModel'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/booking-management/booking-info/booking-info.component.ngfactory.ts